import React from 'react';
import { SECTORS } from './vegaData';

export default function VegaSectors() {
  return (
    <section id="sectors" className="vd-section-y px-6 lg:px-10">
      <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
        <div style={{ maxWidth: '42rem' }}>
          <div className="vd-eyebrow" style={{ marginBottom: '1.25rem' }}>Sectors</div>
          <h2
            className="vd-font-display vd-ink"
            style={{ fontSize: 'clamp(2rem, 4vw, 3.25rem)', lineHeight: 1.08, textWrap: 'balance' }}
          >
            Logical boundaries. <br />
            <span style={{ fontStyle: 'italic' }}>Clear responsibilities.</span>
          </h2>
          <p className="vd-ink-soft" style={{ marginTop: '1.5rem', maxWidth: '36rem', lineHeight: 1.7 }}>
            Group clusters into sectors that match how your org actually thinks — environment, hardware,
            compliance. Each sector is its own scope; together they're one fleet.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-5" style={{ marginTop: '2.5rem' }}>
          {SECTORS.map(s => (
            <article
              key={s.id}
              className={`${s.grad} rounded-3xl relative overflow-hidden transition-transform duration-300 hover:-translate-y-1`}
              style={{ padding: '1.75rem', minHeight: '300px', display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}
            >
              <div className="vd-star-dust absolute inset-0 pointer-events-none" style={{ opacity: 0.2 }} />
              <div style={{ position: 'relative' }}>
                <span
                  className="vd-pill"
                  style={{ background: 'rgba(255,255,255,.7)', borderColor: 'rgba(255,255,255,.9)' }}
                >
                  {s.pill}
                </span>
                <h3
                  className="vd-font-display"
                  style={{ fontSize: '1.875rem', color: 'rgb(30,41,59)', marginTop: '1.25rem' }}
                >
                  {s.title}
                </h3>
                <p style={{ marginTop: '0.5rem', fontSize: '0.875rem', color: 'rgba(51,65,85,.85)', maxWidth: '28ch', lineHeight: 1.6 }}>
                  {s.desc}
                </p>
              </div>
              <div style={{ position: 'relative', display: 'flex', flexWrap: 'wrap', gap: '0.5rem', marginTop: '1.5rem' }}>
                {s.chips.map(c => (
                  <span
                    key={c}
                    style={{
                      fontSize: '0.6875rem',
                      fontFamily: '"JetBrains Mono", monospace',
                      padding: '0.25rem 0.625rem',
                      borderRadius: '0.375rem',
                      background: 'rgba(255,255,255,.7)',
                      color: 'rgb(51,65,85)',
                      border: '1px solid rgba(255,255,255,.9)',
                    }}
                  >
                    {c}
                  </span>
                ))}
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
